import { useState } from 'react';
import type { Role } from '@chemoflow/contracts';
import { Icon } from '../components/Icon.js';
import { useLogin } from '../api/hooks.js';

const DEMO_ROLES: { role: Role; label: string }[] = [
  { role: 'clerk', label: 'クラーク' },
  { role: 'pharm', label: '薬剤師' },
  { role: 'nurse', label: '看護師' },
];

/**
 * ログイン。院内アカウントへ送り出すだけの一枚。
 * Entra接続時は「院内アカウントでログイン」から /api/auth/login へ遷移する。
 */
export function LoginView({ entra }: { entra: boolean }) {
  const [role, setRole] = useState<Role>('clerk');
  const login = useLogin();

  return (
    <div className="login">
      <div className="login-card">
        <div className="login-mark">
          <Icon name="water_drop" />
        </div>
        <h1>ケモフロー</h1>
        <p>外来化学療法 情報共有</p>
        <button
          className="pill-btn"
          type="button"
          disabled={login.isPending}
          onClick={() => {
            if (entra) {
              window.location.href = '/api/auth/login';
              return;
            }
            login.mutate(role);
          }}
        >
          <Icon name="login" />
          院内アカウントでログイン
        </button>
        <p className="fine">
          院内で使っているアカウントと、業務用iPhoneの承認でログインします。
          <br />
          ケモフロー専用のパスワードはありません。
        </p>
        {entra ? null : (
          <div className="login-demo">
            <small>デモ用：ログインする職種（本番ではアカウントから自動で決まります）</small>
            <div className="seg">
              {DEMO_ROLES.map((r) => (
                <button
                  key={r.role}
                  type="button"
                  aria-pressed={role === r.role}
                  onClick={() => setRole(r.role)}
                >
                  {r.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
